export class State {
    error = null;
    success = false;
    isLoading = false;
    dataItem = {};
}
